import { Box, Card, Typography } from "@mui/material";
import React from "react";

export const DatosMedicos = ({ person }) => {
  const { grupoSangre, alergias, enfermedades, medicacion } = person || {};

  if (grupoSangre || alergias || enfermedades || medicacion)
    return (
      <Box display={"flex"} justifyContent={"center"}>
        <Card sx={{ width: "100%", padding: 2 }}>
          <Box textAlign={"start"}>
            {grupoSangre && (
              <Typography variant="h6">
                <b> Grupo Sanguineo:</b> {grupoSangre}
              </Typography>
            )}
            {alergias && (
              <Typography variant="h6">
                <b> Alergias:</b> {alergias}
              </Typography>
            )}
            {enfermedades && (
              <Typography variant="h6">
                <b> Diagnósticos: </b> {enfermedades}
              </Typography>
            )}
            {medicacion && (
              <Typography variant="h6">
                <b> Medicación indicada:</b> {medicacion}
              </Typography>
            )}
          </Box>
        </Card>
      </Box>
    );
};
